// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"defs","attrs":{},"children":[{"tag":"mask","attrs":{"id":"props.overlapMaskId_fill1","maskUnits":"userSpaceOnUse","maskContentUnits":"userSpaceOnUse","mask-type":"luminance","x":"0","y":"0","width":"24","height":"24"},"children":[{"tag":"rect","attrs":{"x":"0","y":"0","width":"24","height":"24","fill":"#fff"}},{"tag":"circle","attrs":{"cx":12,"cy":12,"r":7,"stroke":"#000","strokeLinecap":"square","strokeWidth":"props.strokeWidth","fill":"none"}}]}]},{"tag":"g","attrs":{"id":"round"},"children":[{"tag":"circle","attrs":{"id":"fill1","cx":12,"cy":12,"r":7,"fill":"props.fillColor1","mask":"props.overlapMaskUrl_fill1"}},{"tag":"circle","attrs":{"id":"stroke1","cx":12,"cy":12,"r":7,"stroke":"props.strokeColor1","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const RoundIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'round',
    ref,
    icon: element,
  },
));

RoundIcon.displayName = 'RoundIcon';

export default RoundIcon;
